import React from "react";
import { Link } from "react-router-dom";
import Loading from "../../../../../../components/Loading/Loading";
import localeText from "../../../../../../locale";
import { formatPrice } from "../../../../../../utilities/formatPrice";
import { extrapayWithdrawDetailsPath } from "../constants";
import { formatExtrapayDateTime } from "../formatExtrapay";
import ExtrapayStatusBadge from "./ExtrapayStatusBadge";
import ExtrapayTable from "./ExtrapayTable";

export const getWithdrawStatus = (status) => {
  if (status === "REQUESTED") {
    return { labelKey: "extrapayFlowStatusRequested", tone: "warning" };
  }
  return { labelKey: "extrapayFlowStatusAwaiting", tone: "neutral", raw: status };
};

const WithdrawalsStatementTable = ({ withdrawals, isLoading }) => {
  if (isLoading) {
    return (
      <div className="flex justify-content-center py-4">
        <Loading classNameIcon="text-4xl" />
      </div>
    );
  }

  const columns = [
    {
      key: "request",
      header: localeText("extrapayFlowRequest"),
      render: (row) => row.id,
    },
    {
      key: "date",
      header: localeText("extrapayFlowDate"),
      render: (row) => formatExtrapayDateTime(row.dateRequest),
    },
    {
      key: "exc",
      header: "EXC",
      render: (row) => formatPrice(Number(row.amount) || 0),
    },
    {
      key: "status",
      header: localeText("extrapayFlowSituation"),
      render: (row) => {
        const status = getWithdrawStatus(row.status);
        if (status.raw) return status.raw;
        return <ExtrapayStatusBadge labelKey={status.labelKey} tone={status.tone} />;
      },
    },
    {
      key: "details",
      header: "",
      render: (row) => (
        <Link
          to={{
            pathname: extrapayWithdrawDetailsPath(row.id),
            state: { withdrawal: row },
          }}
          style={{ color: "#335CFF" }}
        >
          {localeText("extrapayFlowViewDetails")}
        </Link>
      ),
    },
  ];

  return (
    <ExtrapayTable
      columns={columns}
      rows={withdrawals}
      emptyMessage={localeText("extrapayFlowWithdrawalsEmpty")}
      rowKey={(row) => row.id}
    />
  );
};

export default WithdrawalsStatementTable;
